import React from "react";
import styles from "./SharedLinkPopup.css";
import copy from "copy-to-clipboard";
import events from "../../../../events";

interface SharedLinkPopupProps {
  fleetName: string;
}

export class SharedLinkPopup extends React.Component<SharedLinkPopupProps> {
  ref?: HTMLDivElement | null;

  state = {
    copiedUrl: false,
    parentWidth: 0
  };

  handleClick = () => {
    copy(window.location.href);
    events.sharing.copiedToClipboard(this.props.fleetName);
    this.setState({ copiedUrl: true });
  };

  applyWidth = () => {
    if (
      this.ref &&
      this.ref.parentElement &&
      this.state.parentWidth !== this.ref.parentElement.offsetWidth
    ) {
      // This component needs to know width of parent to be align
      // It's a trick way...
      // Unfortunately, when element is `position:absolute` element can't get parentWidth by css =(
      this.setState({ parentWidth: this.ref.parentElement.offsetWidth });
    }
  };

  componentDidMount() {
    this.applyWidth();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.applyWidth);
  }

  setRef = (e?: HTMLDivElement | null) => {
    if (e && e.parentElement) {
      this.ref = e;
      window.addEventListener("resize", this.applyWidth);
    }
  };

  render() {
    return (
      <div
        className={styles.container}
        ref={this.setRef}
        style={{ width: this.state.parentWidth }}
      >
        <div className={styles.shareLinkContainer}>
          Compartilhe essa página:
          <input
            className={styles.input}
            value={window.location.href}
            readOnly={true}
          />
          <div className={styles.button} onClick={this.handleClick}>
            {this.state.copiedUrl ? "Link Copiado" : "Copiar link"}
          </div>
        </div>
      </div>
    );
  }
}
